/* import __COLOCATED_TEMPLATE__ from './prep-time-modal.hbs.js'; */
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { parsePrepTimeDuration } from '@dashboard/shared-ui/utils/prep-time';
let PrepTimeModal = (_dec = computed('selectedPrepTime'), _dec2 = computed('selectedPrepTime'), _dec3 = computed('args.initialPrepTime'), _dec4 = computed('args.isOpen'), _class = class PrepTimeModal extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "i18n", _descriptor, this);
    _initializerDefineProperty(this, "customValue", _descriptor2, this);
    _initializerDefineProperty(this, "selectedPrepTime", _descriptor3, this);
    _initializerDefineProperty(this, "customValueInvalid", _descriptor4, this);
    _initializerDefineProperty(this, "isSaving", _descriptor5, this);
    this.selectedPrepTime = args.initialPrepTime;
    if (this.isCustomValue) {
      try {
        const {
          quantity
        } = parsePrepTimeDuration(this.selectedPrepTime);
        this.customValue = quantity.toString();
      } catch {
        this.customValue = '';
      }
    }
  }
  get isCustomValue() {
    return !['PT0M', 'PT15M', 'PT30M', 'PT45M', ''].includes(this.selectedPrepTime);
  }
  get hasNoPrepTime() {
    return this.selectedPrepTime === 'PT0M' || this.selectedPrepTime === '';
  }
  get initialPrepTime() {
    return this.args.initialPrepTime;
  }
  get isModalOpen() {
    return this.args.isOpen;
  }
  validateCustomValue() {
    this.customValueInvalid = false;

    // Check if string is empty or only whitespace
    if (this.customValue.trim() === '') {
      this.customValueInvalid = true;
    }

    // Remove leading/trailing whitespace
    this.customValue = this.customValue.trim();

    // Check for valid unsigned integer pattern (digits only, no signs)
    const integerRegex = /^\d+$/;
    if (!integerRegex.test(this.customValue)) {
      this.customValueInvalid = true;
    }

    // Parse the number and ensure it's within safe integer range
    const num = Number.parseInt(this.customValue, 10);

    // Ensure the string representation matches exactly (no leading zeros except for "0")
    if (!Number.isSafeInteger(num) || num.toString() !== this.customValue) {
      this.customValueInvalid = true;
    }
  }
  updatePrepTime(value) {
    this.selectedPrepTime = value;
    this.customValue = '';
  }
  updateCustomValue(e) {
    this.customValue = e.detail.value;
    this.validateCustomValue();
  }
  showCustomPrepTime() {
    if (this.isCustomValue) {
      return;
    }
    this.customValue = '';
    this.selectedPrepTime = 'CUSTOM';
  }
  async save() {
    if (this.isSaving) {
      return;
    }
    let saveValue = this.selectedPrepTime;
    if (this.isCustomValue) {
      this.validateCustomValue();
      if (this.customValueInvalid) {
        return;
      }
      saveValue = `PT${this.customValue}M`;
    }
    this.isSaving = true;
    const success = await this.args.onSave(saveValue);
    this.isSaving = false;
    if (success) {
      this.close();
    }
  }
  close() {
    this.args.onClose();
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "i18n", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "customValue", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedPrepTime", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "customValueInvalid", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isSaving", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isCustomValue", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "isCustomValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "hasNoPrepTime", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "hasNoPrepTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initialPrepTime", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "initialPrepTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isModalOpen", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "isModalOpen"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updatePrepTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updatePrepTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateCustomValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateCustomValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCustomPrepTime", [action], Object.getOwnPropertyDescriptor(_class.prototype, "showCustomPrepTime"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "save", [action], Object.getOwnPropertyDescriptor(_class.prototype, "save"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _class);
export { PrepTimeModal as default };